import BoardUtils from '../Game/BoardUtils';
// import { getRandom } from '../Utils/Utils';
import { getRandom } from '../State/reducers/boardHelpers';
import { ItemIDs } from '../Config/Items';

export interface ITileType {
    suit: string;
    value: number;
}

export enum Collection {
    DEFAULT = 'default',
    SUMMER = 'summer',
    CLASSIC = 'classic',
    COMING_SOON = 'comingsoon',
}

// moved to separate file for testing
// should use that in game classes and remove this one
export enum Suits {
    BAMBOO = 'bamboo',
    DOTS = 'dots',
    CHARACTERS = 'characters',
    WINDS = 'winds',
    DRAGON = 'dragon',
    FLOWERS = 'flowers',
    SEASONS = 'seasons',
    GOLD = 'gold',
    BOOSTER = 'booster',
    SPECIAL = 'special',
}

export enum SuitValues {
    A = 1,
    B,
    C,
    D,
    E,
    F,
    G,
    H,
    I,
}

export enum QuadValues {
    A = 1,
    B,
    C,
    D,
}

export enum DragonValues {
    A = 1,
    B,
    C,
}

export const BoosterTiles = [ItemIDs.FIRECRACKER];

export const BoosterTilePostfix = 'tile';

// bonus - flowers, seasons...match any in set
export const SpecialMatchingSuits = [Suits.SEASONS, Suits.FLOWERS];

export const ShuffleBlacklist = [Suits.SPECIAL, Suits.BOOSTER];
export const MagnetBlacklist = [Suits.SPECIAL, Suits.BOOSTER];
export const HintBlacklist = [Suits.GOLD, Suits.SPECIAL, Suits.BOOSTER];
export const FirecrackerBlacklist = [Suits.GOLD, Suits.SPECIAL, Suits.BOOSTER];

export class TileSet {
    public static getAllSuitValues(suits: string[]) {
        return suits.reduce(
            (acc, suit) => {
                const vals =
                    suit === Suits.DRAGON
                        ? DragonValues
                        : suit === Suits.WINDS || suit === Suits.SEASONS || suit === Suits.FLOWERS
                            ? QuadValues
                            : SuitValues;
                acc = [
                    ...acc,
                    ...Object.values(vals)
                        .filter(key => !isNaN(Number(key)))
                        .map(value => {
                            return { suit, value };
                        }),
                ];
                return acc;
            },
            [] as ITileType[]
        );
    }

    public static initSet(vals: string[], pairsPerValue: number) {
        // if no vals...get all suits and vals
        const allVals = this.getAllSuitValues(this.getAllSuits());
        const usedVals = vals.length > 0 ? vals.map(t => BoardUtils.convertTileData(t)) : allVals;
        const numPairs = pairsPerValue || 8;
        return usedVals.reduce((acc, t) => {
            const pair = Array(2).fill(t);
            const pairArr = Array(numPairs)
                .fill(pair)
                .reduce((acc2, arr) => {
                    acc2.push(...arr);
                    return acc2;
                }, []);
            acc = [...acc, ...pairArr];
            return acc;
        }, []);
    }

    public static getAllSuits() {
        return Object.keys(Suits);
    }

    public static getBoosterId(index: number): ItemIDs {
        return `${BoosterTiles[index - 1]}_${BoosterTilePostfix}` as ItemIDs;
    }

    public static chooseFromSet(set: ITileType[]) {
        return set.splice(getRandom(0, set.length - 1), 1)[0];
    }

    public static oneOfEach(set: ITileType[]) {
        return set.reduce((acc, t) => {
            if (acc.indexOf(t) === -1) {
                acc.push(t);
            }
            return acc;
        }, []);
    }
}
